import { FC } from 'react';
import './Robot.scss';
import SectionLayout from 'atoms/components/SectionLayout';
import { useTranslation } from 'react-i18next';

const Robot: FC = () => {
  const { t } = useTranslation();

  return (
    <SectionLayout
      type="right"
      header={<span className="title">{t('Robot')}</span>}
    >
      <></>
    </SectionLayout>
  );
};

export default Robot;
